// extracted by mini-css-extract-plugin
module.exports = {"title":"CategoryList_title__3bMJd","menuList_container":"CategoryList_menuList_container__1mfJG"};